export default function OakLogo({ size = 36, glow = false, className = "" }) {
  return (
    <div
      className={`inline-flex items-center justify-center ${className}`}
      style={{
        width: size,
        height: size,
        filter: glow ? "drop-shadow(0 0 18px rgba(0,68,255,0.55))" : "none",
      }}
      data-testid="oak-logo"
    >
      <svg viewBox="0 0 64 64" width={size} height={size} fill="none" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="oak-grad" x1="0" y1="0" x2="64" y2="64" gradientUnits="userSpaceOnUse">
            <stop offset="0" stopColor="#00FF9D" />
            <stop offset="0.55" stopColor="#0044FF" />
            <stop offset="1" stopColor="#5D3FD3" />
          </linearGradient>
        </defs>
        {/* Geometric minimal oak leaf, stylized */}
        <path
          d="M32 4 C34 14 42 20 50 22 C44 26 42 32 42 38 C50 40 56 48 56 56 L38 52 C36 54 34 56 32 60 C30 56 28 54 26 52 L8 56 C8 48 14 40 22 38 C22 32 20 26 14 22 C22 20 30 14 32 4 Z"
          stroke="url(#oak-grad)"
          strokeWidth="2"
          strokeLinejoin="round"
          fill="rgba(0,68,255,0.08)"
        />
        <path d="M32 14 L32 58" stroke="url(#oak-grad)" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    </div>
  );
}
